<template>
  <LayoutPage>

    <page-breadcrumb v-if="!fetching && static" :hierarchy="breadCrumbs"/>

    <StaticSearchBanner
      v-if="renderStaticSearchBanner && !isIndustryCountyOrTown"
      :displayed="showBanner"
      @closeButtonClick="onStaticSearchClose"
      @displaySearchBar="scrollToSearchBar"
    />
    <CandidateSearchBanner
      v-if="renderCandidateSearchBanner"
      :displayed="showBanner"
      :industry="currentPageParameters.industry"
      :location="currentPageParameters.location"
      @closeButtonClick="onCandidateSearchClose"
    />
    <EmployerSearchBanner
      v-if="renderEmployerSearchBanner"
      :displayed="showBanner"
      @closeButtonClick="onEmployerSearchClose"
    />

    <TopText v-if="!fetching && static && !isIndustryCountyOrTown" />

    <div
        class="mx-auto w-full justify-center px-0 lg:px-0"
        :class="{ 'lg:container' : !isIndustryCountyOrTown}"
        ref="searchBar"
    >
      <IndustryStaticSearchBar
          v-if="isTownOrRegionOrCounty"
          page-type="search"
          :job_type="parameters.job_types && parameters.job_types[0]"
          :industry="parameters.industry"
          :location="currentLocationOption"
          :skill="parameters.skill"
          :skill-options="getSearchbarSkillOptions(parameters.industry)"
          :emp_cand="parameters.emp_cand"
      />
      <SearchBar
          v-if="!isIndustryCountyOrTown && !isTownOrRegionOrCounty"
          page-type="search"
          :job_type="parameters.job_types && parameters.job_types[0]"
          :industry="parameters.industry"
          :location="currentLocationOption"
          :skill="parameters.skill"
          :skill-options="getSearchbarSkillOptions(parameters.industry)"
          :emp_cand="parameters.emp_cand"
      />
      <IndustryCountyTownSearchBar
          v-if="isIndustryCountyOrTown"
          page-type="search"
          :job_type="parameters.job_types && parameters.job_types[0]"
          :industry="parameters.industry"
          :location="currentLocationOption"
          :skill="parameters.skill"
          :skill-options="getSearchbarSkillOptions(parameters.industry)"
          :emp_cand="parameters.emp_cand"
      />
    </div>

    <template v-if="!fetching">
      <div
        v-if="!parametersChanged"
        class="mx-auto flex w-full flex-col gap-4 border-x-[1px] border-solid border-grey-20 px-4 py-8 lg:container"
        ref="searchResults"
      >
        <DidYouKnow v-if="didYouKnow" id="didYouKnowBox"
            :title="didYouKnow.title"
            :content="didYouKnow.content"
            />

        <div
          id="countHeading"
          v-if="hasCountHeading && !static"
          class="pagetext-content flex w-full justify-center pb-2"
        >
          <div class="page-description">
            <div class="count-heading" v-html="count_heading"></div>
          </div>
        </div>

        <SearchOrder v-if="currentPageParameters.emp_cand === 'emp'" />

        <!-- <QuickSearch
          v-if="!isNull(quickSearch)"
          :national-count="quickSearch.nationalAgencyCount"
          :national-query="quickSearch.nationalAgencyQuery"
          :covers-count="quickSearch.coversAgencyCount"
          :covers-query="quickSearch.coversAgencyQuery"
        /> -->

        <!-- <div v-if="!static" v-html="countWithinDistanceBand"></div> -->

        <template v-for="(types) in agencyList['items']">
          <div v-if="agencyList['type'] === 'distanceBand'" class="distance-bands-text text-center text-xs md:text-lg"
               v-html="types['distanceBand']"></div>
          <template v-for="(agency, index) in types['agencies']" :key="agency.AgencyTag">
            <SearchResultItem
                :agency="agency"
                :index="index"
                :currentPageParameters="currentPageParameters"
                :firstFreeAgencyIndex="firstFreeAgencyIndex"
                :currentIndustryName="currentIndustryName"
                @contactOpen="onContactOpen"
            />
          </template>
        </template>
        <SearchPagination :static="static"/>
      </div>
      <SearchModified v-else />
    </template>

    <Loading v-else />

    <IndustrySkillLinks v-if="!fetching" />

    <IndustryCountyLinks v-if="!fetching" />

    <PopularLinks v-if="!fetching" />
    
    <BottomText v-if="!fetching" />
  </LayoutPage>
  <ContactSystem :open="contactSystemOpen" />
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import PageBreadcrumb from 'Components/PageBreadcrumb';
import AgencyAdvert from 'Components/AgencyAdvert';
import AcCard from 'Components/AcCard.vue';
import SearchBar from 'Components/SearchBar';
import LayoutPage from 'Components/layouts/LayoutPage';
import StaticSearchBanner from 'Components/Banners/StaticSearchBanner';
import CandidateSearchBanner from 'Components/Banners/CandidateSearchBanner';
import EmployerSearchBanner from 'Components/Banners/EmployerSearchBanner';
import { cookies } from 'Mixins/cookies';
import TopText from 'Components/PageText/TopText';
import BottomText from 'Components/PageText/BottomText';
import IndustrySkillLinks from 'Components/PageText/IndustrySkillLinks';
import IndustryCountyLinks from 'Components/PageText/IndustryCountyLinks';
import PopularLinks from 'Components/PageText/PopularLinks';
import { debounce, isNull } from 'lodash';
import DidYouKnow from 'Components/DidYouKnow.vue';
import IconSearch from 'Components/Icons/IconSearch.vue';
import AdvertCvLibrary from 'Components/AdvertCvLibrary.vue';
import AdvertEmployerDetails from 'Components/AdvertEmployerDetails.vue';
import SearchModified from 'Components/SearchModified.vue';
import SearchPagination from 'Components/SearchPagination';
import SearchOrder from 'Components/SearchOrder.vue';
import QuickSearch from 'Components/QuickSearch.vue';
import ContactSystem from 'Components/ContactSystem';
import IndustryCountyTownSearchBar from 'Components/IndustryCountyTownSearchBar.vue';
import Loading from 'Components/Loading.vue';
import SearchResultItem from "Components/SearchResultItem.vue";
import IndustryStaticSearchBar from "Components/IndustryStaticSearchBar.vue";
import IndustrySelectModal from 'Components/Modals/IndustrySelectModal';``

export default {
  name: 'SearchPage',
  components: {
    IndustryStaticSearchBar,
    SearchResultItem,
    PageBreadcrumb,
    ContactSystem,
    AcCard,
    AdvertCvLibrary,
    AdvertEmployerDetails,
    AgencyAdvert,
    BottomText,
    CandidateSearchBanner,
    DidYouKnow,
    EmployerSearchBanner,
    IconSearch,
    IndustryCountyLinks,
    IndustrySkillLinks,
    PopularLinks,
    LayoutPage,
    QuickSearch,
    SearchBar,
    SearchModified,
    SearchOrder,
    SearchPagination,
    StaticSearchBanner,
    TopText,
    IndustryCountyTownSearchBar,
    Loading,
    IndustrySelectModal
  },
  mixins: [cookies],
  props: {
    static: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enableSearchBanners: false,
      showBanner: false,
      renderStaticSearchBanner: false,
      renderCandidateSearchBanner: false,
      renderEmployerSearchBanner: false,
      debouncedScrollEventHandler: debounce(this.scrollEventHandler, 100),
    };
  },
  methods: {
    isNull,
    ...mapActions('info', ['loadInfo']),
    ...mapActions('search', [
      'logSearch',
      'doSearch',
      'doStaticSearch',
      'getStaticParameters',
    ]),
    ...mapActions('industry', ['getIndustrySkills']),
    ...mapActions('contact', ['setAgency', 'loadPersistentInformation', 'triggerTrackingEvent']),
    ...mapMutations('search', { setSearchStatic: 'setStatic'}),
    ...mapMutations('search', ['setReferringUrl']),
    ...mapMutations('contact', [
      'loadDefaultParameters',
      'setCallingPage',
      'setContactFormType',
      'setContactSocialType',
      'setContactEnquiryType',
      'setOpen',
      'setParameter',
      'setShouldPreselectBranch',
      'setSearchId',
      'setShouldRegister',
      'setStatic',
    ]),
    ...mapMutations('pagetext', ['setPageType']),    
    onContactOpen(event) {
      this.loadDefaultParameters();
      this.setContactFormType(event.form);
      this.setContactEnquiryType(event.type);
      this.setContactSocialType(event.social);
      this.setAgency(event.agency);
      this.setCallingPage(document.location.href);
      this.setSearchId(this.searchId);
      // this lets us know in the state store if we're a static page (true) or search (false)
      // as there is no way to get to the 'props' from the state store
      this.setStatic(this.static); 

      console.log("location:"); console.log(this.location);

      this.setShouldPreselectBranch(
        this.location !== null && event.agency.branches.length !== 0
      );

      if (this.parameters.emp_cand) {
        // set the parameter within the contact store
        this.setParameter({ key: 'emp_cand', value: this.parameters.emp_cand });
      }
      this.loadPersistentInformation();
      this.setShouldRegister();
      this.triggerTrackingEvent();
      this.setOpen();
    },
    scrollEventHandler(event) {
      const currentScrollHeight = window.scrollY;
      const displayBannerHeight = this.$refs.searchResults?.offsetTop;

      this.showBanner = currentScrollHeight > displayBannerHeight;
    },
    scrollToSearchBar() {
      this.$refs.searchBar.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    },
    updateSearchBanner() {
      this.renderEmployerSearchBanner =
          this.parameters.emp_cand === 'emp' &&
          !this.getCookie('hasClosedEmployerSearch');
      this.renderCandidateSearchBanner =
          this.parameters.emp_cand === 'cnd' &&
          !this.getCookie('hasClosedEmployerSearch');
    },
    scrollToSearchResults() {
      const dyn = document.getElementById('didYouKnowBox');
      const countHeading = document.getElementById('countHeading');
      const navBarHeight = document.querySelector('nav').offsetHeight;

      let targetElement = dyn;

      // Check if dyn element is hidden
      if (dyn && (dyn.offsetParent === null || window.getComputedStyle(dyn).display === 'none')) {
        targetElement = countHeading;
      }
      //console.log(targetElement, 'TARGET ELEMENT')

      if (targetElement) {
        setTimeout(function () {
          window.scrollTo({
            top: targetElement.offsetTop - navBarHeight - 15,
            behavior: 'smooth'
          });
        }, 250);
      }
    },
    scrollToSoYouKnow() {
        /**
         * Intended behaviour:
         * 
         * 1. Scroll into view the 'DidYouKnow' component after a search but not on a refresh.
         * 2. Must position under the header bar not occluded by it.
         * 3. The green box must not come in until the first result goes off screen
         */
        return;
        this.$nextTick(function() {
            if (!this.static) {
                const dyn = document.getElementById('didYouKnowBox');
                if (dyn) {
                    setTimeout(function() {
                        window.scrollTo({
                            top: dyn.offsetTop,
                            behavior: 'smooth'
                        });
                        console.log('scroll called');
                    },250);
                }
            }
        });
    },
    onStaticSearchClose() {
      this.showBanner = false;
      setTimeout(() => this.renderStaticSearchBanner = false, 700);
      this.setCookie('hasClosedStaticSearch', true);
    },
    onCandidateSearchClose() {
      this.showBanner = false;
      setTimeout(() => this.renderCandidateSearchBanner = false, 700);
      this.setCookie('hasClosedCandidateSearch', true);
    },
    onEmployerSearchClose() {
      this.showBanner = false;
      setTimeout(() => this.renderEmployerSearchBanner = false, 700);
      this.setCookie('hasClosedEmployerSearch', true);
    },
  },
  computed: {
    quickSearch() {
      return quickSearch;
    },
    ...mapState('search', [
      'agencies',
      'fetching',
      'meta',
      'parameters',
      'currentPageParameters',
      'searchId',
      'quickSearch',
      'location',
      'agencyList'
    ]),
    ...mapGetters('search', ['parametersChanged', 'currentLocationOption']),
    ...mapGetters('industry', ['getSearchbarSkillOptions']),
    ...mapGetters('info', ['getIndustry']),
    ...mapGetters('pagetext', ['hasCountHeading', 'getPageType', 'isIndustryCounty', 'isIndustryTown', 'isTown', 'isRegion', 'isCounty']),
    ...mapState('pagetext', ['count_heading', 'breadCrumbs']),
    ...mapState('contact', {
      contactSystemOpen: 'open',
    }),
    isTownOrRegionOrCounty() {
      return this.isTown || this.isRegion || this.isCounty;
    },
    isIndustryCountyOrTown() {
      return this.isIndustryCounty || this.isIndustryTown;
    },
    firstFreeAgencyIndex() {
      return this.agencies.findIndex((agency) => {
        return agency.FAL;
      });
    },
    currentIndustryName() {
      return this.getIndustry(this.parameters.industry)?.industry_name_1 ?? '';
    },
    didYouKnow() {
      const userType = this.parameters.emp_cand;
      if (!['emp', 'cnd'].includes(userType)) {
        return false;
      }
      // Candidate Did You Know
      if (userType === 'cnd') {
        return {
          title: 'How to find a job using Agency Central',
          content:
            "We've listed recruitment agencies that cover your industry and location. " +
            'You can contact these agencies to find current jobs or send your CV directly to be notified of future opportunities.',
        };
      }

      // Employer Did You Know
      if (this.parameters.location === null) {
        return {
          title: 'Just so you know...',
          content:
            'You can find agencies that are local to you by entering a location in the search box above.',
        };
      }
      return {
        title: 'Just so you know...',
        content: `We've included recruitment agencies from outside of ${this.parameters.location} that recruit in this location and have access to a large number of candidates within the ${this.currentIndustryName} industry.`,
      };
    },
  },
  mounted() {
    this.setSearchStatic(this.static);
    if (this.enableSearchBanners) {
        if (this.static && !this.getCookie('hasClosedStaticSearch')) {
        this.renderStaticSearchBanner = true;
        }
        if (
        this.parameters.emp_cand === 'cnd' &&
        !this.getCookie('hasClosedCandidateSearch')
        ) {
        this.renderCandidateSearchBanner = true;
        }
        if (
        this.parameters.emp_cand === 'emp' &&
        !this.getCookie('hasClosedEmployerSearch')
        ) {
        this.renderEmployerSearchBanner = true;
        }
        window.addEventListener('scroll', this.debouncedScrollEventHandler);
    }
    // Load info for search bar on log search for direct page access
    this.loadInfo();
    this.scrollToSoYouKnow();
},
  unmounted() {
    if (this.enableSearchBanners) {
        window.removeEventListener('scroll', this.debouncedScrollEventHandler);
    }
    this.setPageType('');
  },
  watch: {
    parameters() {
      this.renderEmployerSearchBanner =
        this.parameters.emp_cand === 'emp' &&
        !this.getCookie('hasClosedEmployerSearch');
      this.renderCandidateSearchBanner =
        this.parameters.emp_cand === 'cnd' &&
        !this.getCookie('hasClosedEmployerSearch');
    },
  },
  updated() {
    this.scrollToSoYouKnow();
    this.updateSearchBanner();
    this.setSearchStatic(this.static);
  },
  // Navigating between searches (submit search bar), Static Page pagination
  async beforeRouteUpdate(to, from) {
    let searchParameters = this.parameters;

    if (!this.static) {
      // If a user navigates using the back and forward buttons on search pages,
      // we need to update the search parameters to match the query parameters
      // after the navigation completes
      console.log(
        'User Search Navigation - Ensuring store parameters match query string parameters'
      );
      const queryParameters = to.query;
      // Rename job_types[] to job types as it's submitted as an array
      queryParameters['job_types'] = queryParameters['job_types[]'];
      delete queryParameters['job_types[]'];
      searchParameters = {
        ...searchParameters,
        ...queryParameters,
      };
      console.log('User Search Navigation - Store parameters updated');

      console.log('User Search Navigation - Doing search');
      await this.doSearch(searchParameters);
      console.log('User Search Navigation - Done Search');
    } else {
      // Change page on static page
      console.log('Static Page Change Page - Doing Search');
      await this.doStaticSearch(to.fullPath);
      console.log('Static Page Change Page - Done Search');
    }

    console.log('User Search Route Updated');
    console.log(`Referrer: ${document.location.origin + from.fullPath}`);
    this.setReferringUrl(document.location.origin + from.fullPath);

    console.log('User Search Navigation - Done Search, Logging search');
    this.logSearch('beforeRouteUpdate');

    this.scrollToSearchResults();
  },
  // Navigating from non-search to Search, or first page load
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (from.name === undefined) {
        console.log('SSR Page - Only log search');
        // If from.name is undefined then we've arrived from an external link
        // The page will be rendered on the server, so just log the search.
        // this seems to be some weird quirk of VueJS - no matter where you come from, the
        // from.path will always be '/' if a full page refresh occurred.
        vm.logSearch('beforeRouteEnter/SSR');
        if (!vm.static) {
            vm.scrollToSearchResults();
        }
        return;
      }

      console.log('SPA Page - Setting referring URL');
      console.log(`Referrer: ${document.location.origin + from.fullPath}`);
      vm.setReferringUrl(document.location.origin + from.fullPath);

      let searchParameters = vm.parameters;
      let queryParameters = to.query;

      // Rename job_types[] to job types as it's submitted as an array
      queryParameters['job_types'] = queryParameters['job_types[]'];

      searchParameters = {
        ...searchParameters,
        ...queryParameters,
      };
      
      if (vm.static) {
        console.log('SPA Static Page - Doing Static Search');
        console.log('-> to.fullPath = ' + to.fullPath);
        await vm.doStaticSearch(to.fullPath);
        console.log('SPA Static Page - Done Static Search');
        vm.getIndustrySkills(vm.parameters.industry);
      } else {
        console.log('SPA Search Page - Doing Search');
        await vm.doSearch(searchParameters);
        console.log('SPA Search Page - Done Search');
      }
      console.log('SPA Page - Logging Search');
      vm.logSearch('beforeRouteEnter/SECOND');

      vm.scrollToSearchResults();
      console.log('SPA Page - Logged search');
    });
  },
  beforeRouteLeave(to, from, next) {
    this.setOpen(false);
    next();
  }
};
</script>
